import * as React from "react";
import { FormEdit, Components, Form } from "lexisnexis-form";
import MapComponent from "./lib/MapComponent";
import { IMapConfig } from "../../../common/sharedTypes";

//Add custom components here for them to show up on the editor.
//Components.addComponent("mapComponent", MapComponent);

interface IMapRendererProps {
  mapConfig:IMapConfig
  openNow?: boolean;
}

interface IMapRendererState {
  formSchema: any;
}

export default class MapRenderer extends React.Component<IMapRendererProps, IMapRendererState> {
  state = { 
    formSchema: {"display":"form","components":[
      { 
        "openNow":this.props.openNow,
        "mapItButtonText":"Map It",
        "title":"Nebraska",
        "key":"esriMapping",
        "arcgisUrl":"https://js.arcgis.com/4.10/",
        "geocodeServer":"https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer",
        "esriLoadTimeoutSeconds":"60",
        "externalApiUrl":this.props.mapConfig.webServiceUrl,
        "stateRestrictionWhenSearching":{},
        "defaultCenterPoint":{"defaultLatitude":"","defaultLongitude":""},
        "snapToRoadway":false,"allowUnableToMap":true,"type":"mapComponent","input":true}
      ,
      {
        "type":"button",
        "label":"Submit",
        "key":"submit",
        "disableOnInvalid":true,
        "input":true}
      ]}
  };

  render() {
    return (
      <div>
        <Form
            src={this.state.formSchema}
            options={{
              mapConfig:this.props.mapConfig
              }
            }
          />
      </div>
    );
  }
}
